module.exports = __webpack_public_path__ + "img/google-my-business.bca1ad6a.png";